<template>
  <!-- App -->
  <div class="flex bg-gray-50 font-lexend dark:bg-gray-900">
    <div
      v-if="!$route.meta.hideNav"
      class="lg:block"
      :class="{ hidden: !sidebar, block: sidebar }"
    >
      <div
        class="lg:flex-auto 2xs:w-sidebar w-[300px] bg-white dark:bg-gray-800 overflow-hidden border-r-2 dark:border-gray-700 lg:z-0 z-20 lg:relative fixed"
      >
        <div class="h-screen">
          <Sidebar
            v-if="!$route.meta.hideNav"
            @closeMenuOnOutside="closeSidebar"
            @sidebarToggle="closeSidebar"
          />
        </div>
      </div>
    </div>

    <div class="flex flex-col w-full h-full">
      <Header v-if="!$route.meta.hideNav" @sidebarToggle="openSidebar" />
      <main
        class="main-content flex-auto w-full overflow-x-hidden overflow-y-auto transition-colors"
        :class="[
          !$route.meta.hideNav ? 'h-[calc(100vh-66px)]' : 'h-screen',
          $route.meta.loginPage
            ? `bg-[url('@/assets/img/16389946_5739877.jpg')] dark:bg-[url('@/assets/img/dark-purple-22.jpg')] bg-cover`
            : ``,
        ]"
      >
        <transition name="slide-up" mode="out-in">
          <router-view />
        </transition>
      </main>
    </div>

    <Toast toastId="myToast" />
  </div>
  <!-- End app -->
</template>

<script>
// Vue components
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";

import Toast from "@/components/Toast.vue";

export default {
  name: "App",

  data() {
    return {
      sidebarDark: false,
      sidebar: false,
    };
  },

  components: {
    Header,
    Toast,
    Sidebar,
  },
  methods: {
    openSidebar() {
      this.sidebar = true;
    },
    closeSidebar() {
      this.sidebar = false;
    },
  },
  watch: {
    $route() {
      this.sidebar = false;
    },
  },
};
</script>

<style lang="scss">
.main-content {
  /* *Scroll Bar */
  /* width */
  &::-webkit-scrollbar {
    width: 9px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #4f46e5;
    border-radius: 10px;
  }

  scrollbar-width: 9px;
  scrollbar-color: #4f46e5 transparent;
}

/*
  Enter and leave animations can use different
  durations and timing functions.
*/
.slide-up-enter-active {
  transition: all 0.3s ease-out;
}

.slide-up-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

/* //////////////////////// */

.slide-down-enter-active {
  transition: all 0.3s ease;
}

.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
/* //////////////////////// */

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
